export default __webpack_public_path__ + "static/adelaide-b7c1ffa9679a7fbc42d29df73bee1e6e.png";